// Modal Components
function Modal(props) {
    return (
        <div className={`container quiz_modal d-${props.status} bg-opacity-75}`}>
            <div className="modal-dialog modal_container bg-dark text-light">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Choose Pieces to Promote</h5>
                    </div><hr />
                    <div className="modal-body">
                        <button onClick={props.promoteTo} className="btn btn-primary promotion_btn">{props.pieces.Queen}</button>
                        <button onClick={props.promoteTo} className="btn btn-primary promotion_btn">{props.pieces.Bishop}</button>
                        <button onClick={props.promoteTo} className="btn btn-primary promotion_btn">{props.pieces.Knight}</button>
                        <button onClick={props.promoteTo} className="btn btn-primary promotion_btn">{props.pieces.Rook}</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function GameModal(props) {
    function playAgain(){
        props.gameModalToogle("");
    }
    function quit(){
        props.gameModalToogle("");
    }
    return (
        <div className={`container quiz_modal d-${props.status} bg-opacity-75}`}>
            <div className="modal-dialog modal_container bg-dark text-light">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{props.winner==="Black"|| props.winner==="White"?"Check Mate":"Draw"}</h5>
                    </div><hr />
                    <div className="modal-body">
                        {props.winner} Player Won the Game
                        <div className="hstack gap-3">
                            <div className="p-2">
                                <button className="btn btn-primary" onClick={playAgain}>Play Again</button>
                            </div>
                            <div className="p-2">
                                <button className="btn btn-primary" onClick={quit}>Quit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default Modal;
export { GameModal };